import { useState, useEffect } from 'react';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:5001';

// We fallback to env first, then update with backend response 
const DEFAULT_NUMBER = import.meta.env.VITE_WHATSAPP_NUMBER || "447700000000";

let cachedWhatsApp: { number: string; display: string } | null = null;
let fetchPromise: Promise<void> | null = null;

export function useWhatsAppSettings() {
  const [whatsappNumber, setWhatsappNumber] = useState(cachedWhatsApp?.number || DEFAULT_NUMBER);

  useEffect(() => {
    if (cachedWhatsApp) {
      setWhatsappNumber(cachedWhatsApp.number);
      return;
    }

    if (!fetchPromise) {
      fetchPromise = fetch(`${API_BASE}/api/settings/whatsapp`)
        .then((res) => res.json())
        .then((data) => {
          if (data.ok && data.data) {
            cachedWhatsApp = {
              number: data.data.whatsappNumber,
              display: data.data.whatsappDisplayNumber,
            };
            setWhatsappNumber(cachedWhatsApp.number);
          }
        })
        .catch((err) => {
          console.error("Failed to fetch WhatsApp settings from backend:", err);
        });
    } else {
      fetchPromise.then(() => {
        if (cachedWhatsApp) {
          setWhatsappNumber(cachedWhatsApp.number);
        }
      });
    }
  }, []);

  return { whatsappNumber };
}
